import React from 'react'
import dayjs from 'utils/dayjs'

import { TSubTask } from 'types/GlobalTask'

import { setTimestampDay } from 'utils/dateParser'

import { DateCalendarProps } from 'components_new/atoms/DateCalendar'

import SelectDate from 'components_new/molecules/SelectDate'

export type TTaskDateField = 'completed_date' | 'started_date'

type TTaskDates = Pick<TSubTask, TTaskDateField>

/**
 * Days a task date can be moved to: never in the future, and a start never
 * after the task was done. Moving done before the start moves the start along.
 */
export const getTaskDateLimits = (
  task: TTaskDates,
  field: TTaskDateField
): Pick<DateCalendarProps, 'maxDate'> => {
  const today = dayjs()
  const completed = task.completed_date ? dayjs(task.completed_date) : null

  return {
    maxDate:
      field === 'started_date' && completed?.isBefore(today) ? completed : today
  }
}

interface TaskDateFieldProps {
  field: TTaskDateField
  // the picked day, keeping the date's time of day or else the current one
  onChange: (value: string) => void
  // shown while the date is not set
  placeholder: string
  task: TTaskDates
}

const TaskDateField = (props: TaskDateFieldProps) => {
  const { field, onChange, placeholder, task } = props

  const value = task[field]

  return (
    <SelectDate
      closeOnSelect={true}
      DateCalendarProps={{
        ...getTaskDateLimits(task, field),
        onChange: (day) => {
          if (day) {
            onChange(setTimestampDay(value ?? new Date().toISOString(), day))
          }
        }
      }}
      TextFieldProps={{ placeholder }}
      value={value}
      variant="text"
    />
  )
}

export default TaskDateField
